import { Component, OnInit, Input, Self } from '@angular/core';

import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

import { form } from '@leandredev/dcbm-ng-lib';

import { UiListSubDoc, UIComponentState, ApiHelper } from '@leandredev/common_ng_14';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ITemplateComponent } from '@leandredev/dcbm-common-lib/dist/interfaces';
import { ApiService } from 'src/app/services/api/api.service';

@Component({
  selector: 'app-ui-list-sub-doc-templatefield',
  templateUrl: './TemplateField.component.html',
  styleUrls: ['./TemplateField.component.scss'],
  providers: [UIComponentState],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ])
  ]
})
export class TemplateFieldUIListSubDocComponent extends UiListSubDoc<form.TemplateField> implements OnInit {
  @Input() id = '';

  unVisibleValue = { value: true, values: true };
  public selectedClass = 'ParametreDocumentLink';

  modelComponents: ITemplateComponent[];

  constructor(@Self() protected uIComponentState: UIComponentState, private apiService: ApiService) {
    super(uIComponentState);
    this.columnsToDisplay = ['drag', '_class', 'name', 'size', 'actions'];
    this.classChange(this.selectedClass);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.uIComponentState.id = this.id;

    this.apiService.collections.TemplateComponent.get('*')
      .pipe(ApiHelper.resultToArr('err'))
      .subscribe((components) => {
        this.modelComponents = components;
      });
  }

  addItemByMenu(value: string): void {
    this.classChange(value);
    this.addItem();
  }

  addItem(): void {
    this.inputData.push(this.newElement);
    this.slctTable.renderRows();
    this.expandedElement = this.newElement;
    this.newElement = new this.FormClass();
  }

  addCustomComponentByMenu(component: ITemplateComponent): void {
    this.classChange('ParameterComponent');
    this.newElement.patchValue({ parameters: component.parameters, name: component.name });
    this.addItem();
  }

  addCustomComponentListByMenu(component: ITemplateComponent): void {
    this.classChange('ParameterComponentList');
    this.newElement.patchValue({ parameters: component.parameters, name: `Liste de ${component.name}s` });
    this.addItem();
  }

  drop(event: CdkDragDrop<any>): void {
    moveItemInArray(this.inputData.controls, event.previousIndex, event.currentIndex);
    this.slctTable.renderRows();
  }

  public classToHumanName: { [key: string]: string } = {
    TemplateField: 'Paramêtre Optionnelle',

    ParameterTab: 'Onglet',

    ParameterDivider: 'Diviseur',

    ParameterComponent: 'Composant ',

    ParametreDate: 'Date',

    ParametreNumber: 'Nombre',

    ParametreBoolean: 'Booléen',

    ParametreString: 'Text',

    ParametreDossier: 'Lien vers un Dossier',

    ParameterGroup: 'Groupe',

    ParameterListActService: 'Tableau de Dossier par service',

    ParametreCurrency: 'Devise',

    ParameterComponentList: 'Liste de Composant',

    ParameterTextArea: 'Paragraphe',

    ParametreList: 'Sélecteur',

    ParametreDocument: 'Document',

    ParameterDocumentLink: 'Lien vers un document'
  };

  public classChange(value: string): void {
    let oldVal: any;

    if (this.newElement) {
      oldVal = this.newElement.value;
    }

    switch (value) {
      case 'TemplateField':
        this.FormClass = form.TemplateField;
        break;

      case 'ParameterTab':
        this.FormClass = form.ParameterTab;
        break;

      case 'ParameterDivider':
        this.FormClass = form.ParameterDivider;
        break;

      case 'ParameterComponent':
        this.FormClass = form.ParameterComponent;
        break;

      case 'ParametreDate':
        this.FormClass = form.ParametreDate;
        break;

      case 'ParametreNumber':
        this.FormClass = form.ParametreNumber;
        break;

      case 'ParametreBoolean':
        this.FormClass = form.ParametreBoolean;
        break;

      case 'ParametreString':
        this.FormClass = form.ParametreString;
        break;

      case 'ParametreDossier':
        this.FormClass = form.ParametreDossier;
        break;

      case 'ParameterGroup':
        this.FormClass = form.ParameterGroup;
        break;

      case 'ParameterListActService':
        this.FormClass = form.ParameterListActService;
        break;

      case 'ParametreCurrency':
        this.FormClass = form.ParametreCurrency;
        break;

      case 'ParameterComponentList':
        this.FormClass = form.ParameterComponentList;
        break;

      case 'ParameterTextArea':
        this.FormClass = form.ParameterTextArea;
        break;

      case 'ParametreList':
        this.FormClass = form.ParametreList;
        break;

      case 'ParametreDocument':
        this.FormClass = form.ParametreDocument;
        break;

      case 'ParameterDocumentLink':
        this.FormClass = form.ParameterDocumentLink;
        break;

      default:
        this.FormClass = form.TemplateField;
        break;
    }

    this.newElement = new this.FormClass();

    if (oldVal) {
      delete oldVal._class;
      this.newElement.patchValue(oldVal);
    }

    this.selectedClass = value;
  }
}
